export default "__VITE_ASSET__Crpfx54Y__"